import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  toggle(e) {
    const { currentTarget } = e;
    const controls = currentTarget.getAttribute('aria-controls');
    const expanded = currentTarget.getAttribute('aria-expanded') === 'true';

    document.getElementById(controls).toggleAttribute('inert', expanded);
    if (expanded) {
      currentTarget.setAttribute('aria-expanded', 'false');
    } else {
      currentTarget.setAttribute('aria-expanded', 'true');
    }
  }
}
